export const KEY_OTHER = 'Other';

export const TYPE_OPTIONS = [
  'Public',
  'Private (religious)',
  'Private (no religious affiliation)',
  'Catholic',
  'Youth Correctional Facility',
  'Charter',
  'Department of Defense',
  'Bureau of Indian Affairs',
  'Home School Association',
  'Course/Curriculum Provider',
  'Course Delivery Primarily Online',
  KEY_OTHER
];

export const CREDIT_OPTIONS = [
  'Grants middle school credits only',
  'Grants high school credits only',
  'Awards high school diploma',
  'Awards high school equivalency diploma',
  KEY_OTHER
];

export const ACADEMIC_DISCIPLINES_OPTIONS = [
  'English',
  'Foreign Language',
  'Math',
  'History',
  'Science',
  KEY_OTHER
];

export const TEACHING_METHOD_OPTIONS = [
  'On-site during the day',
  'Online',
  'On-site during the evening',
  'Independent/Home School',
  'Other'
];

// Complete list of  AP Courses from College Board

export const AP_COURSES_OPTIONS = [
    { value: 'AP 2-D Art and Design', label: 'AP 2-D Art and Design' },
    { value: 'AP 3-D Art and Design', label: 'AP 3-D Art and Design' },
    { value: 'AP African American Studies', label: 'AP African American Studies' },
    { value: 'AP Art History', label: 'AP Art History' },
    { value: 'AP Biology', label: 'AP Biology' },
    { value: 'AP Business with Personal Finance', label: 'AP Business with Personal Finance' },
    { value: 'AP Calculus AB', label: 'AP Calculus AB' },
    { value: 'AP Calculus BC', label: 'AP Calculus BC' },
    { value: 'AP Chemistry', label: 'AP Chemistry' },
    { value: 'AP Chinese Language and Culture', label: 'AP Chinese Language and Culture' },
    { value: 'AP Computer Science A', label: 'AP Computer Science A' },
    { value: 'AP Computer Science Principles', label: 'AP Computer Science Principles' },
    { value: 'AP Cybersecurity', label: 'AP Cybersecurity' },
    { value: 'AP Drawing', label: 'AP Drawing' },
    { value: 'AP English Language and Composition', label: 'AP English Language and Composition' },
    { value: 'AP English Literature and Composition', label: 'AP English Literature and Composition' },
    { value: 'AP Environmental Science', label: 'AP Environmental Science' },
    { value: 'AP European History', label: 'AP European History' },
    { value: 'AP French Language and Culture', label: 'AP French Language and Culture' },
    { value: 'AP German Language and Culture', label: 'AP German Language and Culture' },
    { value: 'AP Government and Politics: Comparative', label: 'AP Government and Politics: Comparative' },
    { value: 'AP Government and Politics: United States', label: 'AP Government and Politics: United States' },
    { value: 'AP Human Geography', label: 'AP Human Geography' },
    { value: 'AP Italian Language and Culture', label: 'AP Italian Language and Culture' },
    { value: 'AP Japanese Language and Culture', label: 'AP Japanese Language and Culture' },
    { value: 'AP Latin', label: 'AP Latin' },
    { value: 'AP Macroeconomics', label: 'AP Macroeconomics' },
    { value: 'AP Microeconomics', label: 'AP Microeconomics' },
    { value: 'AP Music Theory', label: 'AP Music Theory' },
    { value: 'AP Networking', label: 'AP Networking' },
    { value: 'AP Physics 1: Algebra-Based', label: 'AP Physics 1: Algebra-Based' },
    { value: 'AP Physics 2: Algebra-Based', label: 'AP Physics 2: Algebra-Based' },
    { value: 'AP Physics C: Electricity and Magnetism', label: 'AP Physics C: Electricity and Magnetism' },
    { value: 'AP Physics C: Mechanics', label: 'AP Physics C: Mechanics' },
    { value: 'AP Precalculus', label: 'AP Precalculus' },
    { value: 'AP Psychology', label: 'AP Psychology' },
    { value: 'AP Research', label: 'AP Research' },
    { value: 'AP Seminar', label: 'AP Seminar' },
    { value: 'AP Spanish Language and Culture', label: 'AP Spanish Language and Culture' },
    { value: 'AP Spanish Literature and Culture', label: 'AP Spanish Literature and Culture' },
    { value: 'AP Statistics', label: 'AP Statistics' },
    { value: 'AP United States History', label: 'AP United States History' },
    { value: 'AP World History: Modern', label: 'AP World History: Modern' }
  ]

// Pre-AP Courses from College Board website
export const PRE_AP_COURSES_OPTIONS = [
  { value: 'Pre-AP Algebra 1', label: 'Pre-AP Algebra 1' },
  { value: 'Pre-AP Algebra 2', label: 'Pre-AP Algebra 2' },
  { value: 'Pre-AP Biology', label: 'Pre-AP Biology' },
  { value: 'Pre-AP Chemistry', label: 'Pre-AP Chemistry' },
  { value: 'Pre-AP English 1', label: 'Pre-AP English 1' },
  { value: 'Pre-AP English 2', label: 'Pre-AP English 2' },
  { value: 'Pre-AP Geometry', label: 'Pre-AP Geometry' },
  { value: 'Pre-AP Physics', label: 'Pre-AP Physics' },
  { value: 'Pre-AP Precalculus', label: 'Pre-AP Precalculus' },
  { value: 'Pre-AP Spanish Language and Culture', label: 'Pre-AP Spanish Language and Culture' },
  { value: 'Pre-AP World History and Geography', label: 'Pre-AP World History and Geography' }
];

export const SAT_ADMINISTRATION_DATES = [
  { value: '2026-05-02', label: 'May 2, 2026' },
  { value: '2026-06-06', label: 'June 6, 2026' },
  { value: '2026-08-22', label: 'August 22, 2026' },
  { value: '2026-09-12', label: 'September 12, 2026' },
  { value: '2026-10-03', label: 'October 3, 2026' },
  { value: '2026-11-07', label: 'November 7, 2026' },
  { value: '2026-12-05', label: 'December 5, 2026' },
  { value: '2027-03-06', label: 'March 6, 2027' },
  { value: '2027-05-01', label: 'May 1, 2027' },
  { value: '2027-06-05', label: 'June 5, 2027' }
];